module.exports = __webpack_public_path__ + "static/img/widget-2.73480474.png";